import React from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";

import AuthManager from "./auth-manager";
import { configurationsFromFile } from "../../apiUtils";

class CallbackPage extends React.Component<any> {
  constructor(props) {
    super(props);
  }
  public onSuccess = () => {
    const redirectUrl = sessionStorage.getItem("redirectUrl") || "/";

    sessionStorage.removeItem("redirectUrl");

    this.props.dispatch(push(redirectUrl));
  };

  public onError = (error) => {
    this.props.dispatch(push("/"));
    console.error(error);
  };

  public componentDidMount() {
    configurationsFromFile().then((configurations) => {
      AuthManager(configurations)
        .userSignInCallback()
        .then(this.onSuccess)
        .catch(this.onError);
    });
  }

  public render() {
    return <div className="fixed-loading" />;
  }
}

export default connect()(CallbackPage);
